import './FormControl.css';
export default {
    "primaryLabel": "FormControl_primaryLabel__qsf7h",
    "primaryLabelOpen": "FormControl_primaryLabelOpen__qsf7h",
    "root": "FormControl_root__qsf7h",
    "primaryLabelRequired": "FormControl_primaryLabelRequired__qsf7h",
    "fieldContainer": "FormControl_fieldContainer__qsf7h",
    "fieldContainerFullWidth": "FormControl_fieldContainerFullWidth__qsf7h",
    "main": "FormControl_main__qsf7h",
    "aside": "FormControl_aside__qsf7h",
    "helperTextWrapper": "FormControl_helperTextWrapper__qsf7h",
    "helperText": "FormControl_helperText__qsf7h",
    "prefix": "FormControl_prefix__qsf7h",
    "suffix": "FormControl_suffix__qsf7h",
    "validationAdornment": "FormControl_validationAdornment__qsf7h",
    "validationAdornmentHelperText": "FormControl_validationAdornmentHelperText__qsf7h",
    "error": "FormControl_error__qsf7h",
    "disabled": "FormControl_disabled__qsf7h"
};
